export const hasUsableIndexedDB = () => {
  if (typeof indexedDB === 'undefined') return false
  try {
    const db = indexedDB.open('_firestore_test_')
    db.onerror = () => { /* noop */ }
    return true
  } catch {
    return false
  }
}
